import create from 'zustand'

const readStoredUser = () => {
  try {
    const raw = localStorage.getItem('adminUser')
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

const stored = readStoredUser()

const useAuthStore = create((set) => ({
  user: stored,
  token: localStorage.getItem('adminToken'),
  adminRoleCodes: stored?.adminRoleCodes ?? [],
  canManageAccess: !!stored?.canManageAccess,
  isSuperuserActor: !!stored?.isSuperuserActor,
  adminPermissions: stored?.adminPermissions ?? {},
  isLoading: false,
  error: null,

  setUser: (user) => {
    if (user) {
      localStorage.setItem('adminUser', JSON.stringify(user))
    } else {
      localStorage.removeItem('adminUser')
    }
    set({
      user,
      adminRoleCodes: user?.adminRoleCodes ?? [],
      canManageAccess: !!user?.canManageAccess,
      isSuperuserActor: !!user?.isSuperuserActor,
      adminPermissions: user?.adminPermissions ?? {},
    })
  },

  setSessionFromVerify: (verifyPayload) => {
    const u = verifyPayload?.user || {}
    const user = {
      ...u,
      adminRoleCodes: verifyPayload.adminRoleCodes ?? [],
      canManageAccess: !!verifyPayload.canManageAccess,
      isSuperuserActor: !!verifyPayload.isSuperuserActor,
      adminPermissions: verifyPayload.adminPermissions ?? {},
    }
    localStorage.setItem('adminUser', JSON.stringify(user))
    set({
      user,
      adminRoleCodes: user.adminRoleCodes,
      canManageAccess: user.canManageAccess,
      isSuperuserActor: user.isSuperuserActor,
      adminPermissions: user.adminPermissions,
    })
  },

  setToken: (token) => {
    if (token) {
      localStorage.setItem('adminToken', token)
    } else {
      localStorage.removeItem('adminToken')
    }
    set({ token })
  },

  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),

  logout: () => {
    localStorage.removeItem('adminToken')
    localStorage.removeItem('adminUser')
    set({
      user: null,
      token: null,
      adminRoleCodes: [],
      canManageAccess: false,
      isSuperuserActor: false,
      adminPermissions: {},
    })
  },
}))

export default useAuthStore
